var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('div',{staticClass:"chart-canvas-container"},[_c('div',{staticClass:"chart-canvas",style:({ width: (_vm.width + "px") })},[_c('canvas',{ref:"chart"})])])])}
var staticRenderFns = []

export { render, staticRenderFns }